module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Thin.56e4e2b.woff2";